var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 40,
    viewBox: "0 0 156 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_170689_1548)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.222 40H5.77778C2.54222 40 0 37.8 0 35V5C0 2.2 2.54222 0 5.77778 0H150.222C153.458 0 156 2.2 156 5V35C156 37.8 153.458 40 150.222 40Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8 11.1C62.7 11.1 61.1 12.7 61.1 14.8C61.1 16.9 62.8 18.5 64.8 18.5C66.9 18.5 68.5 16.9 68.5 14.8C68.6 12.7 66.9 11.1 64.8 11.1ZM64.8 17.1C63.7 17.1 62.7 16.2 62.7 14.8C62.7 13.5 63.7 12.5 64.8 12.5C65.9 12.5 66.9 13.4 66.9 14.8C66.9 16.1 66 17.1 64.8 17.1ZM56.7 11.1C54.6 11.1 53 12.7 53 14.8C53 16.9 54.7 18.5 56.7 18.5C58.7 18.5 60.4 16.9 60.4 14.8C60.4 12.7 58.7 11.1 56.7 11.1ZM56.7 17.1C55.6 17.1 54.6 16.2 54.6 14.8C54.6 13.5 55.6 12.5 56.7 12.5C57.8 12.5 58.8 13.4 58.8 14.8C58.8 16.1 57.8 17.1 56.7 17.1ZM47 12.2V13.8H50.8C50.7 14.7 50.4 15.3 49.9 15.8C49.4 16.3 48.5 17 47 17C44.7 17 42.9 15.1 42.9 12.8C42.9 10.5 44.7 8.6 47 8.6C48.3 8.6 49.2 9.1 49.8 9.7L50.9 8.6C50 7.7 48.7 7 46.9 7C43.7 7 41 9.6 41 12.8C41 16 43.7 18.6 46.9 18.6C48.6 18.6 49.9 18 50.9 17C51.9 16 52.3 14.5 52.3 13.3C52.3 12.9 52.3 12.6 52.2 12.3H47V12.2ZM86.6 13.5C86.3 12.7 85.3 11.1 83.4 11.1C81.5 11.1 79.9 12.6 79.9 14.8C79.9 16.9 81.5 18.5 83.6 18.5C85.3 18.5 86.3 17.5 86.7 16.9L85.4 16.1C85 16.7 84.4 17.1 83.6 17.1C82.8 17.1 82.2 16.7 81.8 16L86.8 13.9L86.6 13.5ZM81.5 14.7C81.5 13.3 82.6 12.5 83.4 12.5C84 12.5 84.6 12.8 84.8 13.3L81.5 14.7ZM77.5 18.3H79.1V7.4H77.5V18.3ZM74.8 11.9C74.4 11.5 73.7 11.1 72.8 11.1C70.9 11.1 69.2 12.7 69.2 14.8C69.2 16.9 70.9 18.5 72.8 18.5C73.7 18.5 74.4 18.1 74.8 17.7H74.9V18.2C74.9 19.6 74.1 20.4 72.9 20.4C71.9 20.4 71.3 19.7 71 19.1L69.6 19.7C70 20.7 71.1 21.9 72.9 21.9C74.8 21.9 76.4 20.8 76.4 18V11.3H74.9V11.9H74.8ZM72.9 17.1C71.8 17.1 70.8 16.2 70.8 14.9C70.8 13.6 71.7 12.6 72.9 12.6C74 12.6 74.9 13.6 74.9 14.9C74.9 16.1 74.1 17.1 72.9 17.1ZM94.3 7.4H90.4V18.3H92V14.2H94.3C96.1 14.2 97.9 12.9 97.9 10.8C97.9 8.7 96.1 7.4 94.3 7.4ZM94.3 12.6H92V8.9H94.3C95.5 8.9 96.2 9.9 96.2 10.8C96.2 11.6 95.5 12.6 94.3 12.6ZM104.4 11.1C103.2 11.1 102 11.6 101.5 12.8L102.9 13.4C103.2 12.8 103.8 12.6 104.4 12.6C105.2 12.6 106.1 13.1 106.1 14V14.1C105.8 13.9 105.2 13.7 104.4 13.7C102.8 13.7 101.3 14.6 101.3 16.2C101.3 17.7 102.6 18.6 104 18.6C105.1 18.6 105.7 18.1 106.1 17.5H106.2V18.3H107.8V14.1C107.7 12.2 106.2 11.1 104.4 11.1ZM104.2 17.1C103.7 17.1 102.9 16.8 102.9 16.2C102.9 15.4 103.8 15 104.6 15C105.3 15 105.7 15.2 106.1 15.4C106 16.3 105.1 17.1 104.2 17.1ZM113.4 11.3L111.5 16H111.4L109.5 11.3H107.7L110.6 17.9L108.9 21.6H110.6L115.1 11.3H113.4ZM98.7 18.3H100.3V7.4H98.7V18.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8 31.3L45.1 29.5H42.8L42.1 31.3H41.4L43.7 25.4H44.4L46.7 31.3H45.8ZM44.9 28.8L44.2 27L43.9 26.1C43.8 26.4 43.7 26.7 43.6 27L42.9 28.8H44.9Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4001 27.1C51.4001 27.7 51.2001 28.2 50.8001 28.5C50.4001 28.8 49.8001 29 49.1001 29H48.4001V31.3H47.7001V25.4H49.3001C50.7001 25.4 51.4001 26 51.4001 27.1ZM48.4001 28.4H49.0001C49.6001 28.4 50.0001 28.3 50.3001 28.1C50.6001 27.9 50.7001 27.6 50.7001 27.2C50.7001 26.8 50.6001 26.5 50.3001 26.4C50.1001 26.2 49.7001 26.1 49.2001 26.1H48.5001V28.4H48.4001Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5001 30.6H57.3001V32.8H56.6001V31.3H56.1001L54.0001 28.5L53.4001 29V31.3H52.7001V25.4H53.4001V28.3L53.9001 27.7L56.0001 25.4H56.9001C56.1001 26.3 55.3001 27.2 54.6001 28L56.5001 30.6Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2 29.6C62.2 30.2 62 30.6 61.7 30.9C61.3 31.2 60.8 31.3 60.1 31.3H58.4V25.4H59.1V27.9H60.1C60.8 27.9 61.4 28 61.7 28.3C62 28.6 62.2 29 62.2 29.6ZM59.1 30.7H60.1C60.6 30.7 60.9 30.6 61.2 30.4C61.4 30.2 61.5 29.9 61.5 29.6C61.5 29.2 61.4 29 61.2 28.8C61 28.6 60.6 28.6 60.1 28.6H59.1V30.7ZM63.9 31.3H63.1V25.4H63.8V31.3H63.9Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 31.3H69.3V26.1H67.4L67.3 27.1C67.1 28.3 66.9 29.3 66.8 29.9C66.7 30.5 66.5 30.9 66.3 31.1C66.1 31.3 65.8 31.4 65.5 31.4C65.3 31.4 65.1 31.4 65 31.3V30.7C65.1 30.8 65.3 30.8 65.5 30.8C65.7 30.8 65.9 30.7 66 30.4C66.1 30.1 66.3 29.5 66.4 28.6C66.5 27.7 66.7 26.6 66.8 25.5H70V31.3Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5001 29.6C75.5001 30.2 75.3001 30.6 75.0001 30.9C74.6001 31.2 74.1001 31.3 73.4001 31.3H71.7001V25.4H72.4001V27.9H73.3001C74.0001 27.9 74.6001 28 74.9001 28.3C75.3001 28.6 75.5001 29 75.5001 29.6ZM72.4001 30.7H73.3001C73.8001 30.7 74.1001 30.6 74.4001 30.4C74.6001 30.2 74.7001 29.9 74.7001 29.6C74.7001 29.2 74.6001 29 74.4001 28.8C74.2001 28.6 73.8001 28.6 73.3001 28.6H72.5001V30.7H72.4001ZM77.1001 31.3H76.4001V25.4H77.1001V31.3Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4 28.3L80.1 25.4H80.9L83.2 28.3V25.4H83.9V28.3L86.2 25.4H87L84.7 28.3L87.1 31.3H86.3L84 28.3V31.3H83.3V28.3L81 31.3H80.1L82.4 28.3Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 28.3L91.5 25.4H92.3L90.3 29V31.3H89.6V29L87.6 25.4H88.4L90 28.3Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7 31.3H96.8L94.1 28.3V31.3H93.4V25.4H94.1V28.3L96.7 25.4H97.5L94.9 28.3L97.7 31.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1 28.3L96.8 31.3H97.7L94.9 28.3L97.5 25.4H96.7L94.1 28.3ZM94.1 28.3V31.3H93.4V25.4H94.1V28.3Z",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.9 31.3H100.1V26.1H98.3V25.4H102.7V26.1H100.9V31.3Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.1 31.3H103.8V25.4H107.1V26.1H104.6V27.9H107V28.5H104.6V30.6H107.1V31.3Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.9 30.6H113.6V32.8H112.9V31.3H112.2V28.6H109.2V31.3H108.5V25.4H109.2V27.9H112.2V25.4H112.9V30.6Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.7 31.3H114.6V30.9L115.3 30.7V26L114.6 25.8V25.4H116.7V25.8L116 26V30.7L116.7 30.9V31.3Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.6 26.8C121.6 27.2 121.5 27.5 121.2 27.7C121 27.9 120.6 28.1 120.2 28.2C120.7 28.3 121.1 28.4 121.3 28.7C121.6 28.9 121.7 29.3 121.7 29.6C121.7 30.2 121.5 30.6 121.1 30.9C120.7 31.2 120.1 31.4 119.3 31.4C118.6 31.4 118 31.3 117.6 31.1V30.4C117.9 30.5 118.2 30.6 118.5 30.7C118.8 30.8 119.1 30.8 119.4 30.8C119.9 30.8 120.3 30.7 120.6 30.5C120.9 30.3 121 30 121 29.7C121 29.3 120.8 29.1 120.5 28.9C120.2 28.7 119.7 28.6 119.1 28.6H118.3V28H119.1C119.7 28 120.1 27.9 120.4 27.7C120.7 27.5 120.8 27.2 120.8 26.9C120.8 26.6 120.7 26.4 120.5 26.2C120.3 26 120 26 119.6 26C119.3 26 119 26 118.8 26.1C118.6 26.2 118.3 26.3 118 26.5L117.6 26C118.2 25.6 118.8 25.4 119.6 25.4C120.2 25.4 120.7 25.5 121 25.8C121.4 26 121.6 26.3 121.6 26.8Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.222 0.8C152.88 0.8 155.076 2.7 155.076 5V35C155.076 37.3 152.88 39.2 150.222 39.2H5.77778C3.12 39.2 0.924444 37.3 0.924444 35V5C0.924444 2.7 3.12 0.8 5.77778 0.8H150.222ZM150.222 0H5.77778C2.54222 0 0 2.3 0 5V35C0 37.8 2.54222 40 5.77778 40H150.222C153.458 40 156 37.8 156 35V5C156 2.3 153.458 0 150.222 0Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7 19.4L10.1 30.7C10.4 31.9 11.5 32.8 12.9 32.8C13.4 32.8 13.9 32.7 14.4 32.4L26.4 25.5L20.7 19.4Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5 17.5L26.3 14.5L20.5 19.7L26.3 25.5L31.4 22.5C32.3 22 32.9 21.1 32.9 20C33 18.9 32.4 18 31.5 17.5Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1 9.30002C10 9.50002 10 9.80002 10 10V30C10 30.3 10 30.5 10.1 30.7L21.1 19.7L10.1 9.30002Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8 20L26.3 14.5L14.3 7.60001C13.9 7.30001 13.4 7.20001 12.8 7.20001C11.5 7.20001 10.3 8.10001 10 9.30001L20.8 20Z",
    fill: "#34A853"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_170689_1548"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 156,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKz);
export default __webpack_public_path__ + "static/media/kz.d0314344437ce9958206a718aee326dc.svg";
export { ForwardRef as ReactComponent };